<template>
  <div class="main-footer">
    <van-tabbar active-color="#ee0a24" class="main-footer" route>
      <van-tabbar-item :to="{name:'Home'}" icon="wap-home-o" replace>测评报告</van-tabbar-item>
      <van-tabbar-item v-if="this.$store.state.auth && this.$store.state.auth.hall.industry ===2" icon="notes-o" replace to="/bid">招标动态
      </van-tabbar-item>
      <van-tabbar-item v-else icon="shop-collect-o" replace to="/reserve">储备库</van-tabbar-item>
      <van-tabbar-item icon="newspaper-o" push url="http://m.youcaiyun.com/">采购导航</van-tabbar-item>
      <van-tabbar-item icon="contact" replace to="/my">我</van-tabbar-item>
    </van-tabbar>
  </div>

</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
.main-footer {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
